import React from 'react';

import { MarkdownContainer } from '../../../components';

type OverviewProps = {
  content: string;
};

export const Overview: React.FC<OverviewProps> = ({ content }) => {
  if (!content) return null;

  return (
    <MarkdownContainer className="text-medium mt-md">
      {content}
    </MarkdownContainer>
  );
};
